import { combineReducers } from "redux";

import playerprofileReducer from "./playerprofile";
import transactionDetailsReducer from "./transactionDetails";
import dashboardReducer from "./dashboard";
import salesAnalyticsReducer from "./salesAnalytics";

const rootReducer = combineReducers({
  playerprofile: playerprofileReducer,
  transactionDetails: transactionDetailsReducer,
  dashboard: dashboardReducer,
  salesAnalytics: salesAnalyticsReducer,
});

export default rootReducer;
